import { environment } from './../../../../../../environments/environment';
import { authenticationService } from './../../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/Services/BaseService';

@Injectable({
  providedIn: 'root',
})
export class PhaseService extends BaseService {

constructor( http: HttpClient, auth: authenticationService) {
  super(http, auth, environment.apiUrl + 'phase');
 }

 getPhaseUsers(flgType: number) {
   return this.http.get<any[]>(environment.apiUrl + 'phase/getPhaseuser/' + flgType, {
    headers: this.headers,
  });
 }
}
